import React, { useState, useRef } from 'react';
import { DentosHeader } from '../components/DentosHeader';
import { DentosFooter } from '../components/DentosFooter';
import { ArrowLeft, ArrowRight, Clock, Mail, CheckCircle } from 'lucide-react';
type PageType = 'home' | 'knowledge' | 'tools' | 'research' | 'dental-kids';
interface ResearchPageProps {
  onNavigate: (page: PageType) => void;
}
interface Research {
  id: number;
  category: string;
  title: string;
  description: string;
  keyStat: string;
  keyStatLabel: string;
  sources: string;
  time: string;
  fullText: string;
}
const researches: Research[] = [{
  id: 1,
  category: 'Казахстан',
  title: 'Рынок стоматологии Казахстана 2025',
  description: 'Объём рынка 380-420 млрд ₸, динамика роста, распределение 6 800 клиник по городам, средние чеки по регионам, структура услуг.',
  keyStat: '380–420 млрд ₸',
  keyStatLabel: 'объём рынка 2024',
  sources: 'МЗ РК, Комитет по статистике',
  time: '8 мин',
  fullText: `DENTOS · Исследования · Аналитика рынка · Март 2026

ОБЗОР РЫНКА

Стоматологический рынок Казахстана — один из наиболее динамично растущих сегментов частной медицины в стране. По данным Комитета по статистике РК и отраслевых аналитиков, совокупный объём рынка платных стоматологических услуг в 2024 году составил порядка 380-420 млрд тенге с прогнозом роста до 520-560 млрд тенге к 2027 году.

Среднегодовой темп роста рынка (CAGR) за период 2020-2024 составил 11-13% — существенно выше общего роста ВВП и инфляции, что свидетельствует о структурном росте спроса на стоматологические услуги.

КОЛИЧЕСТВО КЛИНИК И ДИНАМИКА

По данным Министерства здравоохранения РК на конец 2024 года в стране зарегистрировано более 6 800 стоматологических организаций, из которых:

- Частные клиники и кабинеты — 94% (около 6 400)
- Государственные стоматологические организации — 6% (около 400)

Динамика роста числа частных клиник:

| Год | Кол-во частных клиник | Рост к предыдущему году |
| 2020 | 4 800 | — |
| 2021 | 5 100 | +6.3% |
| 2022 | 5 500 | +7.8% |
| 2023 | 5 950 | +8.2% |
| 2024 | 6 400 | +7.6% |

[Источник: МЗ РК, реестр медицинских организаций, 2024.]

РАСПРЕДЕЛЕНИЕ ПО ГОРОДАМ

Рынок существенно сконцентрирован в двух крупнейших городах:

Алматы — около 2 100 клиник (32% от общего числа). Наибольшая конкуренция, самые высокие средние чеки, наиболее платёжеспособная аудитория.

Астана — около 1 200 клиник (18%). Быстрорастущий рынок на фоне увеличения населения столицы.

Шымкент — около 650 клиник (10%). Третий по величине рынок с активным ростом среднего класса.

Остальные города — около 2 450 клиник (40%). Меньшая конкуренция, ниже чеки, дефицит квалифицированных специалистов.

СРЕДНИЕ ЧЕКИ ПО РЕГИОНАМ

По данным агрегаторов записи и отраслевых опросов DENTOS:

| Город | Средний чек одного визита | Средний LTV пациента (5 лет) |
| Алматы | 45 000 — 65 000 ₸ | 400 000 — 700 000 ₸ |
| Астана | 38 000 — 55 000 ₸ | 320 000 — 550 000 ₸ |
| Шымкент | 25 000 — 38 000 ₸ | 200 000 — 380 000 ₸ |
| Регионы | 15 000 — 28 000 ₸ | 120 000 — 250 000 ₸ |

СТРУКТУРА РЫНКА ПО ТИПУ УСЛУГ

- Терапия (пломбирование, лечение каналов) — 38% выручки рынка
- Ортопедия и протезирование — 24%
- Имплантация — 18% (+32% за 2 года — наиболее быстрорастущий сегмент)
- Ортодонтия — 11%
- Детская стоматология — 6%
- Прочее — 3%

Ключевой тренд: имплантация и ортодонтия растут за счёт роста среднего класса и доступности рассрочек. Детская стоматология недооценена — при правильном позиционировании это высокомаржинальный и лояльный сегмент.

КЛЮЧЕВЫЕ ТРЕНДЫ 2025

Цифровизация записи. Более 40% пациентов в Алматы и Астане ищут клинику через 2ГИС или Google Maps. Клиники без актуального профиля теряют до 30% потенциального потока.

Рост запросов через WhatsApp. По данным исследования DENTOS, 55% владельцев отмечают что пациенты предпочитают записываться через мессенджеры а не по телефону.

Дефицит кадров. 68% владельцев клиник называют найм квалифицированных врачей главной операционной проблемой. Средняя зарплата хорошего врача-имплантолога в Алматы выросла за 2 года на 40%.

Консолидация. Появляются первые стоматологические сети с 3-5 точками. Пока их доля мала — менее 3% рынка — но тренд на укрупнение очевиден.`
}, {
  id: 2,
  category: 'Бенчмарки',
  title: 'Бенчмарки: средние показатели по клиникам Казахстана',
  description: 'Финансовые, операционные и маркетинговые нормы рынка. Где ваша клиника относительно 180 других — по марже, no-show, конверсии и LTV.',
  keyStat: '42–48%',
  keyStatLabel: 'средняя конверсия звонков',
  sources: 'DENTOS Research, опрос 180 клиник',
  time: '7 мин',
  fullText: `DENTOS · Исследования · Бенчмарки · Март 2026

ЗАЧЕМ НУЖНЫ БЕНЧМАРКИ

Большинство владельцев стоматологий оценивают свою клинику в вакууме. Они знают свои цифры — но не знают хорошо это или плохо относительно рынка.

Бенчмарки решают эту проблему. Они дают систему координат: где вы находитесь сейчас и куда двигаться.

Данные собраны DENTOS на основе опросов владельцев клиник Казахстана в 2024-2025 годах (выборка: 180 клиник в Алматы, Астане и регионах).

ФИНАНСОВЫЕ ПОКАЗАТЕЛИ

Чистая маржа:

| Уровень | Маржа | Комментарий |
| Слабо | Менее 8% | Клиника на грани, любой кризис — убыток |
| Средне | 8-15% | Работает но без запаса прочности |
| Хорошо | 15-25% | Норма здорового бизнеса |
| Отлично | Выше 25% | Системная клиника с оптимизированными расходами |

Медианный показатель по рынку Казахстана: 11-14%. То есть большинство клиник работают ниже нормы.

Выручка на одно кресло в месяц:

| Уровень | Выручка / кресло |
| Слабо | Менее 400 000 ₸ |
| Средне | 400 000 — 700 000 ₸ |
| Хорошо | 700 000 — 1 100 000 ₸ |
| Отлично | Выше 1 100 000 ₸ |

ОПЕРАЦИОННЫЕ ПОКАЗАТЕЛИ

Конверсия входящего звонка в запись:

| Уровень | Конверсия |
| Слабо | Менее 40% |
| Средне | 40-60% |
| Хорошо | 60-75% |
| Отлично | Выше 75% |

Медиана по рынку: 42-48%. Более половины клиник теряют каждый второй звонок.

Процент неявок (No-show):

| Уровень | No-show |
| Критично | Выше 20% |
| Плохо | 15-20% |
| Средне | 10-15% |
| Хорошо | 5-10% |
| Отлично | Менее 5% |

Медиана по рынку: 14-18%. Клиники без системы напоминаний теряют в среднем 16% рабочего времени на пустые кресла.

Загрузка кресел:

| Уровень | Загрузка |
| Слабо | Менее 50% |
| Средне | 50-70% |
| Хорошо | 70-85% |
| Отлично | Выше 85% |

Медиана по рынку: 58-65%. Большинство клиник имеют существенный резерв роста без найма новых врачей.

МАРКЕТИНГОВЫЕ ПОКАЗАТЕЛИ

Стоимость привлечения одного нового пациента (CAC):

| Город | Средний CAC |
| Алматы | 8 000 — 18 000 ₸ |
| Астана | 6 000 — 14 000 ₸ |
| Регионы | 3 000 — 8 000 ₸ |

При LTV пациента 300 000 — 500 000 ₸ — даже CAC 18 000 ₸ является отличной инвестицией. Проблема в том что большинство клиник не считают CAC вообще.

Доля повторных пациентов:

| Уровень | Доля повторных |
| Слабо | Менее 40% |
| Средне | 40-55% |
| Хорошо | 55-70% |
| Отлично | Выше 70% |

КАДРОВЫЕ ПОКАЗАТЕЛИ

Текучка персонала в год:

Средняя по рынку: 28-35% для администраторов, 12-18% для врачей. Клиники с системой мотивации и KPI: 8-12% для администраторов, 5-7% для врачей.

Соотношение ФОТ к выручке:

Норма: 38-45% от выручки на всех сотрудников включая врачей. Выше 50% — сигнал к пересмотру структуры мотивации.`
}, {
  id: 3,
  category: 'Казахстан',
  title: 'Ежегодный отчёт отрасли: стоматология Казахстана 2025',
  description: 'Пенсионная схема и её последствия, рост имплантологии на 32%, дефицит детских стоматологов, пять трендов которые изменят рынок к 2027 году.',
  keyStat: '+32%',
  keyStatLabel: 'рост сегмента имплантации',
  sources: 'МЗ РК, КазНМУ, DENTOS',
  time: '9 мин',
  fullText: `DENTOS · Исследования · Ежегодный отчёт · Март 2026

ГЛАВНЫЕ СОБЫТИЯ ГОДА

Январь 2025 года стал для рынка шоковым. Задержание 11 человек и вовлечение 42 клиник в схему по незаконному выводу пенсионных накоплений на сумму 200 млрд тенге ударило по репутации всей отрасли.

Последствия: ужесточение контроля ЕНПФ за заявками на использование пенсионных накоплений, снижение количества одобрений, усиление налоговых проверок в сегменте. Часть клиник потеряла 15-25% выручки связанной с пенсионными выплатами.

РОСТ ИМПЛАНТОЛОГИИ

Сегмент имплантации вырос на 32% в денежном выражении. Основные драйверы: рост доходов среднего класса, доступность рассрочек через банки-партнёры, снижение стоимости корейских и китайских имплантов.

ДЕФИЦИТ ДЕТСКИХ СТОМАТОЛОГОВ

По данным КазНМУ и ассоциации стоматологов РК, дефицит детских стоматологов в стране составляет около 40% от потребности. В регионах ситуация критическая — некоторые области имеют одного детского стоматолога на 50 000 детей.

ТРЕНДЫ КОТОРЫЕ ИЗМЕНЯТ РЫНОК К 2027 ГОДУ

Тренд 1 — Цифровая стоматология. CAD/CAM технологии, интраоральные сканеры, цифровые слепки — всё это переходит из категории "дорогая новинка" в "стандарт хорошей клиники". По прогнозам к 2027 году более 30% клиник Алматы будут иметь интраоральный сканер.

Тренд 2 — Телестоматология. Консультации онлайн, дистанционный контроль ортодонтического лечения, удалённая диагностика по фото — этот рынок в Казахстане пока в зачаточном состоянии но растёт на 60-80% в год.

Тренд 3 — Детская стоматология как отдельный бизнес. Первые специализированные детские стоматологии с геймификацией, детским дизайном и специально обученным персоналом появляются в Алматы и Астане. Родители готовы платить premium за комфорт ребёнка.

Тренд 4 — Сетевые клиники. Первые сети с 3-5 точками под единым брендом. Пока их доля мала но модель доказывает экономическую эффективность: централизованный маркетинг, общий call-центр, стандартизированные процессы.

Тренд 5 — Автоматизация записи. Онлайн-запись через сайт и 2ГИС, автоматические напоминания через WhatsApp, CRM-системы — переходят из разряда конкурентного преимущества в базовый стандарт.

ПРОГНОЗ НА 2026-2027

Рынок продолжит расти на 10-12% в год в денежном выражении. Количество клиник будет расти медленнее — около 6-7% — что означает увеличение средней выручки на клинику.

Основные риски: ужесточение регулирования, дефицит кадров, рост аренды в крупных городах.

Основные возможности: недостаточное проникновение стоматологических услуг в регионах (75% населения РК не посещало стоматолога в 2024 году), рост детской стоматологии, цифровизация.`
}, {
  id: 4,
  category: 'Опросы',
  title: 'Опрос владельцев клиник Казахстана 2025',
  description: '180 владельцев ответили на вопросы о главных болях, финансовой прозрачности, операционной зрелости и планах на год. Прямые цитаты.',
  keyStat: '77%',
  keyStatLabel: 'не знают точную прибыль клиники',
  sources: 'DENTOS Research, 180 клиник',
  time: '8 мин',
  fullText: `DENTOS · Исследования · Опрос · Март 2026

МЕТОДОЛОГИЯ

В ноябре-декабре 2024 года DENTOS провёл опрос 180 владельцев стоматологических клиник в Алматы, Астане, Шымкенте и регионах. Опрос проводился онлайн и в формате глубинных интервью.

Выборка: клиники с оборотом от 500 000 до 15 000 000 тенге в месяц, от 1 до 8 кресел.

ГЛАВНЫЕ БОЛИ ВЛАДЕЛЬЦЕВ

Участникам задавали вопрос: "Что является вашей главной проблемой как владельца клиники прямо сейчас?"

| Проблема | Доля респондентов |
| Найм и удержание персонала | 68% |
| Нестабильный поток пациентов | 54% |
| Высокие операционные расходы | 47% |
| Сложности с администрированием | 38% |
| Конкуренция и демпинг | 35% |
| Нехватка времени на управление | 31% |
| Непонимание финансовых показателей | 28% |
| Юридические и налоговые риски | 22% |

ФИНАНСОВАЯ ПРОЗРАЧНОСТЬ

Знаете ли вы точную чистую прибыль своей клиники за прошлый месяц?

- Да, веду управленческий учёт — 23%
- Примерно знаю — 41%
- Нет, смотрю только на кассу — 36%

Вывод: 77% владельцев не имеют точного представления о прибыльности своего бизнеса.

Платите ли вы себе фиксированную зарплату как директору?

- Да, фиксированная сумма — 18%
- Иногда фиксированная иногда нет — 29%
- Беру из кассы по необходимости — 53%

ОПЕРАЦИОННАЯ ЗРЕЛОСТЬ

Есть ли у вас описанные регламенты для сотрудников?

- Да, большинство процессов описаны — 19%
- Частично — 38%
- Нет, работаем по интуиции — 43%

Используете ли вы CRM систему?

- Да, полноценно — 27%
- Частично или в Excel — 34%
- Нет — 39%

Слушаете ли вы записи звонков своих администраторов?

- Регулярно — 12%
- Иногда — 24%
- Никогда или нет записи — 64%

ПЛАНЫ НА 2025-2026

Что планируете сделать в ближайший год?

| План | Доля |
| Увеличить поток пациентов | 71% |
| Нанять новых врачей | 48% |
| Внедрить CRM | 34% |
| Автоматизировать запись | 31% |
| Открыть второй кабинет или точку | 22% |
| Выйти из личного приёма | 19% |
| Нанять управляющего | 16% |

ЦИТАТЫ ИЗ ГЛУБИННЫХ ИНТЕРВЬЮ

"Я открыл клинику пять лет назад. Первые три года работал как врач и думал что зарабатываю. Потом посчитал — и оказалось что мой сосед-наёмник зарабатывает столько же а головной боли у него нет."
— Владелец клиники, Алматы, 4 кресла

"Главная проблема — я не знаю где теряю деньги. Выручка есть, пациенты есть, а денег в конце месяца мало. Куда уходит — непонятно."
— Владелец клиники, Астана, 3 кресла

"Нанял администратора с опытом. Думал всё будет хорошо. Через месяц подключил запись звонков — и обнаружил что она сливает каждый второй звонок. Улыбается хорошо, записывать не умеет."
— Владелец клиники, Шымкент, 2 кресла`
}, {
  id: 5,
  category: 'Мировые данные',
  title: 'Мировой рынок стоматологии 2025',
  description: 'Объём $167 млрд с ростом до $246 млрд к 2030 году. Данные ВОЗ: 3.5 млрд человек с заболеваниями полости рта. Региональное распределение и драйверы роста.',
  keyStat: '$167 млрд',
  keyStatLabel: 'объём мирового рынка 2023',
  sources: 'Grand View Research, WHO, Mordor Intelligence',
  time: '7 мин',
  fullText: `DENTOS · Исследования · Мировые данные · Март 2026

Источники: Grand View Research "Dental Services Market Report 2024", Mordor Intelligence "Global Dental Market 2024-2029", WHO Oral Health Report 2022.

ОБЪЁМ И РОСТ МИРОВОГО РЫНКА

По данным Grand View Research мировой рынок стоматологических услуг достиг $167.1 млрд в 2023 году и прогнозируется к росту до $246.5 млрд к 2030 году при среднегодовом темпе роста 5.8% CAGR.

[Источник: Grand View Research, "Dental Services Market Size & Share Report, 2030", 2024.]

Рынок стоматологического оборудования и расходных материалов отдельно оценивается в $42.3 млрд с прогнозом роста до $60.1 млрд к 2029 году.

[Источник: Mordor Intelligence, "Dental Equipment Market — Growth, Trends and Forecasts 2024-2029".]

РЕГИОНАЛЬНОЕ РАСПРЕДЕЛЕНИЕ

- Северная Америка — 38% мирового рынка. США лидируют с объёмом $58 млрд. Средний чек одного визита: $250-350.
- Европа — 28%. Германия, Великобритания, Франция — крупнейшие рынки. Высокий уровень страхового покрытия.
- Азиатско-Тихоокеанский регион — 22% и наиболее быстро растущий. Китай, Япония, Индия — рост 7-9% в год.
- Остальной мир включая СНГ — 12%. Значительное недопроникновение услуг создаёт потенциал роста.

КЛЮЧЕВЫЕ ДРАЙВЕРЫ РОСТА

Имплантология — главный двигатель. Рынок дентальных имплантов вырос с $4.6 млрд в 2020 до $6.8 млрд в 2024 году. Прогноз: $11.2 млрд к 2030.

[Источник: MarketsandMarkets, "Dental Implants Market Global Forecast to 2030", 2024.]

Эстетическая стоматология. Рынок отбеливания и виниров растёт на 8-10% в год на фоне роста социальных сетей и культуры внешнего вида. Глобальный объём: $7.4 млрд в 2024.

Превентивная стоматология. ВОЗ фиксирует сдвиг от лечения к профилактике. Программы регулярных осмотров и профессиональной гигиены растут в развитых рынках.

ДАННЫЕ ВОЗ ПО ЗДОРОВЬЮ ПОЛОСТИ РТА

По данным ВОЗ (WHO Oral Health Report, 2022):

- 3.5 млрд человек страдают от заболеваний полости рта — это почти половина населения Земли
- Кариес постоянных зубов — самое распространённое заболевание в мире
- 1 млрд человек страдают от тяжёлых заболеваний пародонта
- Только 60% детей в мире имеют доступ к базовой стоматологической помощи

[Источник: WHO, "Global oral health status report: towards universal health coverage for oral health by 2030", 2022.]

Для Казахстана эти данные означают огромный нераскрытый потенциал рынка — особенно в регионах где проникновение стоматологических услуг значительно ниже среднемирового.

ТРЕНДЫ КОТОРЫЕ ФОРМИРУЮТ БУДУЩЕЕ ОТРАСЛИ

Искусственный интеллект в диагностике. Системы AI для анализа рентгеновских снимков уже используются в клиниках США и Европы. Точность диагностики кариеса с AI достигает 94% против 75-80% у врача без вспомогательных инструментов.

[Источник: Schwendicke F. et al., "Artificial intelligence in dentistry: chances and challenges", Journal of Dental Research, 2020.]

Телестоматология. Ускоренная пандемией, телестоматология закрепилась как отдельный сегмент. По данным ADA (American Dental Association) 29% стоматологов США использовали телемедицину в 2023 году против 4% в 2019.`
}, {
  id: 6,
  category: 'Мировые данные',
  title: 'Цифровизация стоматологии — Deloitte и McKinsey',
  description: 'Три волны цифровой трансформации, данные по внедрению технологий в США и Европе против Казахстана, экономический эффект автоматизации для клиник.',
  keyStat: '−45%',
  keyStatLabel: 'снижение no-show после автоматизации',
  sources: 'Deloitte, McKinsey, ADA, Dental Tribune',
  time: '8 мин',
  fullText: `DENTOS · Исследования · Мировые данные · Март 2026

Источники: Deloitte "Future of Health 2040", McKinsey "The Next Normal in Healthcare", Dental Tribune International.

КЛЮЧЕВЫЕ ВЫВОДЫ

По данным McKinsey & Company, здравоохранение — одна из последних крупных отраслей которая проходит цифровую трансформацию. Стоматология традиционно отставала даже от общей медицины — но разрыв стремительно сокращается.

[Источник: McKinsey & Company, "The Next Normal in Healthcare: How COVID-19 Changed the Way Americans Work and Live", 2021.]

ТРИ ВОЛНЫ ЦИФРОВИЗАЦИИ СТОМАТОЛОГИИ

Волна 1 (2015-2020) — Цифровая запись и базовые CRM. Онлайн-запись, электронные карты, SMS-напоминания.

Волна 2 (2020-2025) — Цифровые клинические инструменты. Интраоральные сканеры, CAD/CAM протезирование, цифровая рентгенология, AI-диагностика.

Волна 3 (2025-2030) — Интегрированные платформы. Телестоматология, предиктивная аналитика, персонализированные протоколы лечения на основе данных пациента.

ДАННЫЕ ПО ВНЕДРЕНИЮ ТЕХНОЛОГИЙ

По данным Dental Tribune International и ADA Health Policy Institute:

Интраоральные сканеры:

| Регион | Доля клиник 2024 |
| США | 47% (против 18% в 2019) |
| Европа | 38% |
| Казахстан (оценка DENTOS) | Менее 5% |

CAD/CAM системы:

| Регион | Доля клиник |
| США | 34% |
| Европа | 28% |
| Казахстан | Менее 2% |

AI-диагностика (анализ снимков):

| Регион | Доля клиник 2024 |
| США | 12% (прогноз 35% к 2027) |
| Европа | 8% |
| Казахстан | Единичные случаи |

[Источник: ADA Health Policy Institute, "Dental Practice Report 2024".]

ЭКОНОМИЧЕСКИЙ ЭФФЕКТ ЦИФРОВИЗАЦИИ

По данным исследования Deloitte "Future of Health":

Клиники внедрившие цифровые инструменты записи и напоминаний показывают:

- Снижение no-show на 35-45%
- Рост повторных визитов на 22-28%
- Рост удовлетворённости пациентов (NPS) на 15-20 пунктов

[Источник: Deloitte Insights, "Future of Health: How COVID-19 Accelerated Health Technology", 2021.]

ЧТО ЭТО ЗНАЧИТ ДЛЯ КАЗАХСТАНА

Казахстан находится в начале Волны 1-2. Это означает что у клиник которые начнут цифровизацию сейчас есть окно возможностей в 3-5 лет до того как это станет обязательным стандартом.

Приоритетные шаги для казахстанских клиник:

- Онлайн-запись и автоматические напоминания (ROI очевиден и быстр)
- CRM с историей пациента
- Запись звонков и аналитика
- Интраоральный сканер (для клиник с оборотом от 3 млн/мес)`
}, {
  id: 7,
  category: 'Мировые данные',
  title: 'Детская стоматология — глобальные тренды',
  description: '620 млн детей с кариесом молочных зубов. Геймификация снижает тревожность на 60%. Данные по Казахстану: 72-78% детей 6-7 лет с кариесом. Экономика детского пациента.',
  keyStat: '72–78%',
  keyStatLabel: 'детей 6-7 лет с кариесом в РК',
  sources: 'WHO, FDI, AAPD, КазНМУ',
  time: '9 мин',
  fullText: `DENTOS · Исследования · Мировые данные · Март 2026

Источники: WHO Oral Health Report 2022, FDI World Dental Federation "Oral Health Atlas 2021", AAPD (American Academy of Pediatric Dentistry) Clinical Guidelines.

МАСШТАБ ПРОБЛЕМЫ

По данным ВОЗ кариес молочных зубов является самым распространённым хроническим заболеванием у детей в мире — в 5-10 раз чаще чем астма.

Глобальная статистика (WHO, 2022):

- 60-90% школьников имеют кариес молочных или постоянных зубов
- Кариес молочных зубов затрагивает 620 миллионов детей — каждого девятого ребёнка на планете
- Только 40% детей в странах с низким доходом получают лечение
- Нелеченный кариес у детей приводит к боли, нарушению питания, пропускам школы, снижению качества жизни

[Источник: WHO, "Global oral health status report", 2022.]

ДАННЫЕ ПО КАЗАХСТАНУ

По данным исследований КазНМУ и Министерства здравоохранения РК:

| Показатель | Значение |
| Распространённость кариеса у детей 6-7 лет | 72-78% |
| Распространённость кариеса у детей 12 лет | 58-65% |
| Охват профилактическими осмотрами в регионах | Менее 30% |
| Дефицит детских стоматологов | Около 40% от потребности |

[Источник: Национальный доклад о здоровье населения и деятельности системы здравоохранения РК, 2023.]

ГЕЙМИФИКАЦИЯ — МИРОВОЙ СТАНДАРТ ДЕТСКОЙ СТОМАТОЛОГИИ

По данным AAPD (Американской академии детской стоматологии) применение техник поведенческого менеджмента и игровых подходов снижает стоматологическую тревожность у детей на 40-60% и увеличивает комплаентность лечения на 35%.

[Источник: AAPD, "Behavior Guidance for the Pediatric Dental Patient", Clinical Practice Guideline, 2023.]

Ключевые элементы современного детского приёма по мировым стандартам:

Tell-Show-Do (скажи-покажи-сделай). Снижает тревожность на 45%.

Дизайн клиники. Яркие цвета, игровые зоны, мультфильмы на потолке, тематические кабинеты. Исследования показывают что дизайн влияет на восприятие боли у детей.

Геймификация лечения. Баллы за чистку зубов, приложения для контроля гигиены, награды за посещение — увеличивают частоту профилактических визитов на 28%.

[Источник: Bedi R., "Innovations in paediatric dentistry", British Dental Journal, 2019.]

ЭКОНОМИКА ДЕТСКОЙ СТОМАТОЛОГИИ

Детская стоматология — стратегически наиболее ценный сегмент для клиники:

LTV детского пациента. Ребёнок который начал ходить к стоматологу в 3-4 года и не боится — потенциально ваш пациент на 20+ лет. При 2-3 визитах в год и среднем чеке 25 000 ₸ это 1 500 000 ₸ только от одного пациента за 20 лет. Плюс его родители которых он может привести.

Семейный эффект. По данным опросов DENTOS клиники специализирующиеся на детях получают в среднем 2.4 взрослых пациента с каждой детской семьи в течение первого года.

Меньше конкуренция. Специализированных детских стоматологий в Казахстане критически мало. Первая клиника в районе которая создаёт по-настоящему комфортный детский опыт — забирает рынок.`
}, {
  id: 8,
  category: 'Бенчмарки',
  title: 'Управление клиникой — данные ADA и Dental Economics',
  description: 'Финансовые бенчмарки США адаптированные для Казахстана. Стоимость привлечения пациента, no-show решения, удержание пациентов — с реальными цифрами.',
  keyStat: '5–7x',
  keyStatLabel: 'дешевле удержать чем привлечь',
  sources: 'ADA Health Policy Institute, Dental Economics, Bain & Company',
  time: '10 мин',
  fullText: `DENTOS · Исследования · Мировые данные · Март 2026

Источники: ADA Health Policy Institute "Dental Practice Report 2024", Dental Economics "Annual Practice Survey 2023", MGMA (Medical Group Management Association).

ФИНАНСОВЫЕ БЕНЧМАРКИ США — С АДАПТАЦИЕЙ ДЛЯ КАЗАХСТАНА

ADA ежегодно публикует детальные финансовые показатели стоматологических практик США. Это наиболее полная база бенчмарков в мире.

Структура расходов (США, 2023):

| Статья расходов | США | Норма Казахстан |
| ФОТ персонала (без врача-владельца) | 28-32% | 25-35% |
| Расходные материалы | 6-8% | 8-12% |
| Аренда | 5-8% | 8-15% |
| Маркетинг | 3-5% | 3-8% |
| Оборудование и амортизация | 4-6% | 3-6% |
| Прочие расходы | 5-7% | 4-7% |
| Итого расходов | 51-66% | 51-83% |
| Чистая прибыль владельца | 34-49% | 17-49% |

[Источник: ADA Health Policy Institute, "2023 Survey of Dental Practice", 2024.]

Ключевое наблюдение: американские стоматологии тратят значительно меньше на аренду и расходные материалы в процентном отношении. Казахстанские клиники переплачивают за материалы (нет прямых дистрибьюторских контрактов) и аренду (нет рычага на переговорах).

СТОИМОСТЬ ПРИВЛЕЧЕНИЯ ПАЦИЕНТА — МИРОВЫЕ ДАННЫЕ

По данным Dental Economics и различных маркетинговых исследований:

США:

- Средний CAC через digital-маркетинг: $150-250 (~70 000 — 115 000 ₸)
- Средний CAC через рекомендации: $25-50 (~12 000 — 23 000 ₸)
- Средний LTV пациента: $8 000 — $15 000 за всё время (~3.7 — 7 млн ₸)
- ROI маркетинга при правильной настройке: 5-15x

[Источник: Dental Economics, "Practice Marketing Benchmark Report", 2023.]

Для Казахстана (адаптация):

При LTV пациента 300 000 — 500 000 ₸ и CAC 8 000 — 18 000 ₸ ROI составляет 17-62x. Это означает что казахстанские клиники хронически недоинвестируют в маркетинг — боятся тратить 15 000 ₸ на привлечение пациента который принесёт 400 000 ₸.

NO-SHOW — МИРОВЫЕ ДАННЫЕ И РЕШЕНИЯ

По данным MGMA и различных медицинских исследований:

- Средний no-show в медицине без системы напоминаний: 18-25%
- После внедрения SMS-напоминаний: снижение на 29-36%
- После внедрения двух напоминаний (за 48 часов и за 2 часа): снижение на 38-45%
- После внедрения системы депозитов за запись: снижение на 52-67%

[Источник: Parikh K. et al., "Patient No-Show Predictive Model Development and Validation", Health Informatics Journal, 2022.]

Финансовый эффект снижения no-show с 18% до 7% для клиники с оборотом 3 млн ₸ в месяц: +330 000 ₸ выручки ежемесячно без единого нового пациента.

УДЕРЖАНИЕ ПАЦИЕНТОВ — МИРОВЫЕ ДАННЫЕ

По данным Bain & Company:

Увеличение удержания пациентов на 5% увеличивает прибыль на 25-95%.

[Источник: Reichheld F., Schefter P., "The Economics of E-Loyalty", Harvard Business Review, 2000.]

Применительно к стоматологии (данные Dental Economics):

- Клиники с активной программой удержания показывают рост выручки на 18-24% выше чем клиники без неё
- Стоимость удержания существующего пациента в 5-7 раз ниже стоимости привлечения нового
- Пациенты которые приходят по рекомендации имеют на 37% более высокий LTV чем пациенты пришедшие через рекламу

[Источник: Dental Economics, "Patient Retention and Practice Growth", 2022.]

ПРОИЗВОДИТЕЛЬНОСТЬ ТРУДА ВРАЧА

По данным ADA (2023):

Средняя выручка врача-стоматолога в США: $706 000 в год (~326 млн ₸) или около $58 800 в месяц (~27 млн ₸).

Для сравнения — средняя выручка с кресла в Казахстане составляет 600 000 — 900 000 ₸ в месяц (при полной загрузке) что в 18-25 раз меньше американского показателя. Разрыв объясняется разницей в чеках а не в производительности труда.

Ключевой показатель ADA — процедур в день:

- Менее 8 процедур: низкая производительность
- 8-12 процедур: средняя
- Более 12 процедур: высокая

[Источник: ADA Health Policy Institute, "Dental Practice Report 2024", 2024.]

ИТОГОВЫЕ ВЫВОДЫ ДЛЯ КАЗАХСТАНСКОГО РЫНКА

Казахстанские клиники недооценивают LTV пациента. Думая в категориях среднего чека (35 000 ₸) вместо LTV (300 000 — 500 000 ₸) — принимают неверные решения о маркетинге и удержании.

Операционная эффективность ниже мирового уровня. No-show 15-18% против 5-7% в лучших мировых практиках. Конверсия звонков 42-48% против 70-80%. Загрузка кресел 58-65% против 80-90%.

Маркетинг недофинансирован. Американские клиники тратят 3-5% выручки на маркетинг. Казахстанские — 1-3%. При значительно более высоком потенциальном ROI.

Детская стоматология — неиспользованная возможность. При распространённости кариеса у детей 72-78% и дефиците специалистов 40% — это крупнейшая незаполненная ниша рынка.`
}];
const categories = ['Все', 'Казахстан', 'Мировые данные', 'Бенчмарки', 'Опросы'];
const keyFacts = [{
  icon: '🏥',
  text: '6 800+ клиник в Казахстане'
}, {
  icon: '💰',
  text: '380–420 млрд ₸ объём рынка'
}, {
  icon: '📊',
  text: '77% владельцев не знают прибыль'
}, {
  icon: '👶',
  text: '72% детей 6-7 лет имеют кариес'
}, {
  icon: '📉',
  text: '−45% no-show при автоматизации'
}];
const categoryColor: Record<string, string> = {
  Казахстан: 'bg-blue-50 text-blue-600',
  Бенчмарки: 'bg-purple-50 text-purple-600',
  Опросы: 'bg-orange-50 text-orange-600',
  'Мировые данные': 'bg-teal-50 text-teal-600'
};
// Robust article body renderer
function ArticleBody({
  text
}: {
  text: string;
}) {
  const lines = text.split('\n');
  const result: React.ReactNode[] = [];
  let i = 0;
  let keyIdx = 0;
  const nextKey = () => `el-${keyIdx++}`;
  while (i < lines.length) {
    const raw = lines[i];
    const line = raw.trim();
    // Skip empty lines
    if (!line) {
      i++;
      continue;
    }
    // Citation lines: wrapped in [...]
    if (line.startsWith('[') && line.endsWith(']')) {
      result.push(<p key={nextKey()} className="text-xs text-gray-400 italic border-l-2 border-gray-200 pl-3 my-3 leading-relaxed" data-id="element-662">
          {line.slice(1, -1)}
        </p>);
      i++;
      continue;
    }
    // Table: line starts with |
    if (line.startsWith('|')) {
      const tableLines: string[] = [];
      while (i < lines.length && lines[i].trim().startsWith('|')) {
        tableLines.push(lines[i].trim());
        i++;
      }
      const rows = tableLines.map(l => l.split('|').map(c => c.trim()).filter(c => c !== ''));
      if (rows.length === 0) continue;
      result.push(<div key={nextKey()} className="overflow-x-auto my-5 rounded-lg border border-gray-100" data-id="element-663">
          <table className="w-full text-sm border-collapse min-w-[300px]" data-id="element-664">
            <thead data-id="element-665">
              <tr className="bg-[#0F1E3C] text-white" data-id="element-666">
                {rows[0].map((cell, ci) => <th key={ci} className="px-3 py-2.5 text-left font-semibold text-xs" data-id="element-667">
                    {cell}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-668">
              {rows.slice(1).map((row, ri) => <tr key={ri} className={ri % 2 === 0 ? 'bg-white' : 'bg-[#F4F6F9]'} data-id="element-669">
                  {row.map((cell, ci) => <td key={ci} className="px-3 py-2.5 text-gray-700 border-b border-gray-100 text-xs md:text-sm" data-id="element-670">
                      {cell}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>);
      continue;
    }
    // Quote: starts with " (Russian opening quote)
    if (line.startsWith('\u201c') || line.startsWith('"')) {
      const quoteText = line;
      i++;
      let attribution = '';
      if (i < lines.length && lines[i].trim().startsWith('—')) {
        attribution = lines[i].trim();
        i++;
      }
      result.push(<blockquote key={nextKey()} className="border-l-4 border-[#00C2D4] pl-4 py-3 my-5 bg-[#F4F6F9] rounded-r-lg" data-id="element-671">
          <p className="text-gray-700 italic leading-relaxed text-sm" data-id="element-672">
            {quoteText}
          </p>
          {attribution && <p className="text-sm text-[#00C2D4] font-semibold mt-2" data-id="element-673">
              {attribution}
            </p>}
        </blockquote>);
      continue;
    }
    // Section heading: ALL CAPS Cyrillic/Latin, no lowercase, length > 3
    // Use a simple heuristic: if the line has no lowercase letters and is > 3 chars
    const hasLower = /[а-яёa-z]/.test(line);
    const looksLikeHeading = !hasLower && line.length > 3 && !line.startsWith('-') && !line.startsWith('|');
    if (looksLikeHeading) {
      result.push(<h3 key={nextKey()} className="text-xs font-bold text-[#0F1E3C] uppercase tracking-widest mt-8 mb-3 pb-2 border-b border-gray-100" data-id="element-674">
          {line}
        </h3>);
      i++;
      continue;
    }
    // Bullet list
    if (line.startsWith('- ')) {
      const items: string[] = [];
      while (i < lines.length && lines[i].trim().startsWith('- ')) {
        items.push(lines[i].trim().slice(2));
        i++;
      }
      result.push(<ul key={nextKey()} className="space-y-2 my-4" data-id="element-675">
          {items.map((item, li) => <li key={li} className="flex items-start gap-2 text-gray-700 leading-relaxed text-sm" data-id="element-676">
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#00C2D4] flex-shrink-0" data-id="element-677" />
              <span data-id="element-678">{item}</span>
            </li>)}
        </ul>);
      continue;
    }
    // Regular paragraph
    result.push(<p key={nextKey()} className="text-gray-700 leading-relaxed mb-3 text-sm" data-id="element-679">
        {line}
      </p>);
    i++;
  }
  return <div data-id="element-680">{result}</div>;
}
export function ResearchPage({
  onNavigate
}: ResearchPageProps) {
  const [activeCategory, setActiveCategory] = useState('Все');
  const [selectedResearch, setSelectedResearch] = useState<Research | null>(null);
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const topRef = useRef<HTMLDivElement>(null);
  const filtered = activeCategory === 'Все' ? researches : researches.filter(r => r.category === activeCategory);
  const openResearch = (r: Research) => {
    setSelectedResearch(r);
    setTimeout(() => {
      topRef.current?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 50);
  };
  const closeResearch = () => {
    setSelectedResearch(null);
    setTimeout(() => {
      topRef.current?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 50);
  };
  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.includes('@')) setEmailSent(true);
  };
  return <div ref={topRef} className="min-h-screen bg-[#F4F6F9]" style={{
    fontFamily: "'Montserrat', sans-serif"
  }} data-id="element-681">
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" data-id="element-682" />

      <DentosHeader currentPage="research" onNavigate={onNavigate} data-id="element-683" />

      {/* HERO */}
      <section className="pt-28 md:pt-32 pb-12 md:pb-16 bg-[#0F1E3C] text-white relative overflow-hidden" data-id="element-684">
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 60% 50% at 70% 50%, rgba(0,194,212,0.12) 0%, transparent 70%)'
      }} data-id="element-685" />
        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-686">
          {selectedResearch ? <div data-id="element-687">
              <button onClick={closeResearch} className="flex items-center gap-2 text-[#00C2D4] hover:text-white transition-colors text-sm mb-5 group" style={{
            fontWeight: 600
          }} data-id="element-688">
                <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" data-id="element-689" />
                Все исследования
              </button>
              <span className="text-[#00C2D4] uppercase text-xs mb-2 block tracking-widest" style={{
            fontWeight: 600
          }} data-id="element-690">
                {selectedResearch.category}
              </span>
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white mb-4 leading-tight max-w-4xl" style={{
            fontWeight: 800
          }} data-id="element-691">
                {selectedResearch.title}
              </h1>
              <div className="flex flex-wrap items-center gap-3 text-[#A0AEC0] text-xs sm:text-sm" data-id="element-692">
                <span className="flex items-center gap-1.5" data-id="element-693">
                  <Clock size={13} data-id="element-694" />
                  {selectedResearch.time} чтения
                </span>
                <span className="text-gray-600 hidden sm:inline" data-id="element-695">•</span>
                <span className="text-xs" data-id="element-696">{selectedResearch.sources}</span>
              </div>
            </div> : <div data-id="element-697">
              <span className="text-[#00C2D4] uppercase text-xs sm:text-sm mb-3 block" style={{
            fontWeight: 600,
            letterSpacing: '3px'
          }} data-id="element-698">
                ИССЛЕДОВАНИЯ
              </span>
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white mb-5 leading-tight max-w-3xl" style={{
            fontWeight: 800
          }} data-id="element-699">
                Данные которых нет больше нигде
              </h1>
              <p className="text-[#A0AEC0] text-base md:text-xl max-w-2xl leading-relaxed mb-8" style={{
            fontWeight: 400
          }} data-id="element-700">
                Аналитика рынка стоматологии Казахстана, бенчмарки по клиникам и
                адаптированные мировые отчёты. Всё в одном месте.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-701">
                {[{
              value: '8',
              label: 'исследований'
            }, {
              value: '180+',
              label: 'клиник в выборке'
            }].map((stat, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-xl px-5 py-3 backdrop-blur-sm" data-id="element-702">
                    <div className="text-[#00C2D4] text-xl sm:text-2xl" style={{
                fontWeight: 800
              }} data-id="element-703">
                      {stat.value}
                    </div>
                    <div className="text-[#A0AEC0] text-xs sm:text-sm" style={{
                fontWeight: 500
              }} data-id="element-704">
                      {stat.label}
                    </div>
                  </div>)}
              </div>
            </div>}
        </div>
      </section>

      {/* CATEGORY FILTER */}
      {!selectedResearch && <div className="sticky top-[60px] md:top-[72px] z-40 bg-white border-b border-gray-200 shadow-sm py-3 overflow-x-auto" data-id="element-705">
          <div className="container mx-auto px-4 md:px-6" data-id="element-706">
            <div className="flex space-x-2 min-w-max" data-id="element-707">
              {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className="px-4 py-1.5 rounded-full text-xs sm:text-sm transition-all duration-200 whitespace-nowrap" style={{
            fontWeight: 600,
            fontFamily: "'Montserrat', sans-serif",
            background: activeCategory === cat ? '#00C2D4' : 'white',
            color: activeCategory === cat ? 'white' : '#4A5568',
            border: activeCategory === cat ? '1.5px solid #00C2D4' : '1.5px solid #E2E8F0'
          }} data-id="element-708">
                  {cat}
                </button>)}
            </div>
          </div>
        </div>}

      {/* MAIN CONTENT */}
      <div className="container mx-auto px-4 md:px-6 py-8 md:py-12" data-id="element-709">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10" data-id="element-710">
          {/* LEFT CONTENT */}
          <div className="w-full lg:w-[68%]" data-id="element-711">
            {selectedResearch ? <div className="bg-white rounded-2xl shadow-sm p-5 sm:p-8 md:p-10" data-id="element-712">
                {/* Key stat hero */}
                <div className="bg-[#00C2D4] rounded-xl p-4 sm:p-6 mb-7 text-white flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-713">
                  <div className="flex-shrink-0" data-id="element-714">
                    <div className="text-3xl sm:text-4xl md:text-5xl" style={{
                  fontWeight: 800
                }} data-id="element-715">
                      {selectedResearch.keyStat}
                    </div>
                    <div className="text-white/80 text-xs sm:text-sm mt-1" style={{
                  fontWeight: 500
                }} data-id="element-716">
                      {selectedResearch.keyStatLabel}
                    </div>
                  </div>
                  <div className="hidden sm:block h-12 w-px bg-white/20" data-id="element-717" />
                  <p className="text-white/80 text-xs sm:text-sm leading-relaxed" style={{
                fontWeight: 400
              }} data-id="element-718">
                    {selectedResearch.description}
                  </p>
                </div>

                <ArticleBody text={selectedResearch.fullText} data-id="element-719" />

                <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-720">
                  <button onClick={closeResearch} className="flex items-center gap-2 text-[#00C2D4] group" style={{
                fontWeight: 700
              }} data-id="element-721">
                    <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" data-id="element-722" />
                    Вернуться к исследованиям
                  </button>
                  <span className="text-xs text-gray-400" data-id="element-723">
                    {selectedResearch.time} чтения · {selectedResearch.sources}
                  </span>
                </div>
              </div> : <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6" data-id="element-724">
                {filtered.map(r => <div key={r.id} className="bg-white rounded-xl shadow-sm flex flex-col border-l-4 border-transparent hover:border-[#00C2D4] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300" data-id="element-725">
                    <div className="p-5 flex flex-col h-full" data-id="element-726">
                      <div className="flex items-center justify-between mb-3" data-id="element-727">
                        <span className={`text-xs px-2.5 py-1 rounded-full uppercase tracking-wide ${categoryColor[r.category] || 'bg-gray-100 text-gray-600'}`} style={{
                    fontWeight: 600
                  }} data-id="element-728">
                          {r.category}
                        </span>
                        <span className="text-xs text-gray-400 flex items-center gap-1" style={{
                    fontWeight: 500
                  }} data-id="element-729">
                          <Clock size={11} data-id="element-730" />
                          {r.time}
                        </span>
                      </div>

                      <h3 className="text-[#0F1E3C] text-sm sm:text-base mb-2 leading-snug flex-grow" style={{
                  fontWeight: 700
                }} data-id="element-731">
                        {r.title}
                      </h3>

                      <p className="text-gray-500 text-xs sm:text-sm leading-relaxed mb-4 line-clamp-2" style={{
                  fontWeight: 400
                }} data-id="element-732">
                        {r.description}
                      </p>

                      <div className="bg-[#00C2D4] rounded-lg px-3 py-2.5 mb-4 flex items-center gap-3" data-id="element-733">
                        <div className="text-white text-lg sm:text-xl" style={{
                    fontWeight: 800
                  }} data-id="element-734">
                          {r.keyStat}
                        </div>
                        <div className="text-white/80 text-xs leading-tight" style={{
                    fontWeight: 500
                  }} data-id="element-735">
                          {r.keyStatLabel}
                        </div>
                      </div>

                      <div className="flex items-center justify-between pt-3 border-t border-gray-100" data-id="element-736">
                        <span className="text-xs text-gray-400 truncate max-w-[55%]" data-id="element-737">
                          {r.sources}
                        </span>
                        <button onClick={() => openResearch(r)} className="text-[#00C2D4] text-xs flex items-center gap-1 hover:gap-2 transition-all flex-shrink-0 ml-2" style={{
                    fontWeight: 700
                  }} data-id="element-738">
                          Читать <ArrowRight size={12} data-id="element-739" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>}
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="w-full lg:w-[32%]" data-id="element-740">
            <div className="lg:sticky lg:top-32 space-y-5" data-id="element-741">
              {/* Key facts */}
              <div className="bg-white rounded-xl shadow-sm p-5" data-id="element-742">
                <h3 className="text-[#0F1E3C] text-sm mb-4 flex items-center gap-2" style={{
                fontWeight: 700
              }} data-id="element-743">
                  <span data-id="element-744">📊</span> Ключевые цифры рынка
                </h3>
                <ul className="space-y-3" data-id="element-745">
                  {keyFacts.map((fact, i) => <li key={i} className="flex items-start gap-3" data-id="element-746">
                      <span className="text-base flex-shrink-0" data-id="element-747">
                        {fact.icon}
                      </span>
                      <span className="text-gray-700 text-xs sm:text-sm leading-snug" style={{
                    fontWeight: 500
                  }} data-id="element-748">
                        {fact.text}
                      </span>
                    </li>)}
                </ul>
              </div>

              {/* Next report */}
              <div className="bg-[#0F1E3C] rounded-xl p-5 text-white" data-id="element-749">
                <div className="flex items-center gap-2 mb-2" data-id="element-750">
                  <span data-id="element-751">🔔</span>
                  <h3 className="text-xs sm:text-sm" style={{
                  fontWeight: 700
                }} data-id="element-752">
                    Следующий отчёт
                  </h3>
                </div>
                <p className="text-[#00C2D4] text-base sm:text-lg mb-2" style={{
                fontWeight: 800
              }} data-id="element-753">
                  Отчёт Q2 2026
                </p>
                <p className="text-[#A0AEC0] text-xs mb-4 leading-relaxed" style={{
                fontWeight: 400
              }} data-id="element-754">
                  Новые данные по имплантологии, ценам и кадровому рынку выйдут
                  в июне 2026.
                </p>
                {emailSent ? <div className="flex items-center gap-2 text-[#00C2D4] text-xs" style={{
                fontWeight: 600
              }} data-id="element-755">
                    <CheckCircle size={15} data-id="element-756" /> Вы в списке ожидания!
                  </div> : <form onSubmit={handleEmailSubmit} className="space-y-2" data-id="element-757">
                    <div className="relative" data-id="element-758">
                      <Mail size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-759" />
                      <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ваш@email.com" className="w-full bg-white/10 border border-white/20 rounded-lg pl-8 pr-3 py-2 text-white placeholder-gray-500 text-xs focus:outline-none focus:border-[#00C2D4]" style={{
                    fontFamily: "'Montserrat', sans-serif"
                  }} data-id="element-760" />
                    </div>
                    <button type="submit" className="w-full bg-[#00C2D4] text-white py-2 rounded-lg text-xs transition-colors hover:bg-[#00a8b8]" style={{
                  fontWeight: 700
                }} data-id="element-761">
                      Получить когда выйдет
                    </button>
                  </form>}
              </div>

              {/* Dental Kids banner */}
              <div className="bg-gradient-to-br from-[#0F1E3C] to-[#00C2D4] rounded-xl p-5 text-white" data-id="element-762">
                <span className="bg-white/10 px-2 py-1 rounded text-xs tracking-wider mb-3 inline-block" style={{
                fontWeight: 700
              }} data-id="element-763">
                  DENTAL KIDS
                </span>
                <h3 className="text-sm mb-3 leading-tight" style={{
                fontWeight: 700
              }} data-id="element-764">
                  Первая клиника в районе которая внедрит это — заберёт рынок
                </h3>
                <div className="space-y-1.5 mb-4 text-xs text-white/80" data-id="element-765">
                  {['730 контактов в год', '5-7% no-show', 'Запуск за 10 дней'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-766">
                      <div className="w-1 h-1 bg-white rounded-full flex-shrink-0" data-id="element-767" />
                      {item}
                    </div>)}
                </div>
                <button className="w-full bg-white text-[#0F1E3C] py-2 rounded-lg text-xs flex items-center justify-center gap-2 hover:bg-gray-100 transition-colors" style={{
                fontWeight: 700
              }} data-id="element-768">
                  Узнать подробнее <ArrowRight size={12} data-id="element-769" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM BANNER */}
      <section className="bg-white py-12 md:py-16 border-t border-gray-200" data-id="element-770">
        <div className="container mx-auto px-4 md:px-6 text-center max-w-xl" data-id="element-771">
          <span className="text-[#00C2D4] uppercase text-xs tracking-widest mb-3 block" style={{
          fontWeight: 700
        }} data-id="element-772">
            DENTOS RESEARCH
          </span>
          <h2 className="text-[#0F1E3C] text-2xl sm:text-3xl md:text-4xl mb-4 leading-tight" style={{
          fontWeight: 800
        }} data-id="element-773">
            Участвуйте в следующем опросе
          </h2>
          <p className="text-gray-500 text-sm sm:text-base mb-7 leading-relaxed" style={{
          fontWeight: 400
        }} data-id="element-774">
            Мы собираем данные по рынку раз в год. Ваши ответы анонимны и
            помогают всей отрасли.
          </p>
          <button className="inline-flex items-center gap-2 bg-[#0F1E3C] text-white px-6 sm:px-8 py-3 rounded-lg transition-all hover:bg-[#1a2e4a] text-sm" style={{
          fontWeight: 700
        }} data-id="element-775">
            Принять участие <ArrowRight size={16} data-id="element-776" />
          </button>
        </div>
      </section>

      <DentosFooter onNavigate={onNavigate} data-id="element-777" />
    </div>;
}